document.addEventListener('DOMContentLoaded', function(){
    let currentPrice = document.querySelector('.current_prices').innerText;
    let sale_price = null;

    if(document.querySelector('.sale_price')){
        sale_price = document.querySelector('.sale_price').innerText;
    }

    setTimeout(function(){
        if(sale_price) {
            currentPrice = sale_price;
        }
        document.querySelector('.sticky-atc__price').innerHTML = '&nbsp;— ' + currentPrice;
        document.querySelector('.sticky-atc__price').classList.add('is-active');
    }, 1500)
    let allOptions = document.querySelectorAll('[data-value-handle]')
    for (let a=0; a < allOptions.length; a++){
        allOptions[a].addEventListener('click', function(){
            document.querySelector('.sticky-atc__price').classList.remove('is-active');
            setTimeout(function(){
                let sale_price = null;
                if(document.querySelector('.sale_price')){
                    sale_price = document.querySelector('.sale_price').innerText;
                }
                let currentPrice = document.querySelector('.current_prices').innerText;
                if(sale_price) {
                    currentPrice = sale_price;
                }
                document.querySelector('.sticky-atc__price').innerHTML = '&nbsp;— ' + currentPrice;
                document.querySelector('.sticky-atc__price').classList.add('is-active');
            }, 1500)
        })
    }

    $( window ).on( "load", function() {
        document.querySelector('.sticky-atc__price').classList.remove('is-active');
        setTimeout(function(){
            let currentPrice = document.querySelector('.current_prices').innerText;
            let sale_price = null;

            if(document.querySelector('.sale_price')){
                sale_price = document.querySelector('.sale_price').innerText;
            }

            if(sale_price) {
                currentPrice = sale_price;
            }

            document.querySelector('.sticky-atc__price').innerHTML = '&nbsp;— ' + currentPrice;
            document.querySelector('.sticky-atc__price').classList.add('is-active');
        }, 1500)
    })

    // $(document).on('change', '.rc_widget__option__input', function(e) {
    //     if (this.classList.contains('rc_widget__option__input--onetime')) {
    //         document.querySelector('.button--add-to-cart .text').innerHTML = "Add to cart";
    //     } else {
    //         document.querySelector('.button--add-to-cart .text').innerHTML = "Subscribe";
    //     }

    //     document.querySelector('.sticky-atc__price').classList.remove('is-active');
    //     setTimeout(function(){
    //         let currentPrice = document.querySelector('.current_prices').innerText;
    //         let sale_price = null;

    //         if(document.querySelector('.sale_price')){
    //             sale_price = document.querySelector('.sale_price').innerText;
    //         }

    //         if(sale_price) {
    //             currentPrice = sale_price;
    //         }
    //         document.querySelector('.sticky-atc__price').innerHTML = '&nbsp;— ' + currentPrice;
    //         document.querySelector('.sticky-atc__price').classList.add('is-active');
    //     }, 1500)
    // })
})